// export const setCookie = (name, value) => {
//   const expires = new Date("2099-12-31T23:59:59Z");

//   document.cookie = `${name}=${encodeURIComponent(
//     value,
//   )};expires=${expires.toUTCString()};path=/;domain=.bigfootmail.com;SameSite=Lax`;
// };

// export const getCookie = (name) => {
//   const nameEQ = `${name}=`;

//   const cookies = document.cookie.split(";");

//   for (let cookie of cookies) {
//     cookie = cookie.trim();

//     if (cookie.startsWith(nameEQ)) {
//       return decodeURIComponent(cookie.substring(nameEQ.length));
//     }
//   }

//   return null;
// };

export const setCookie = (name, value) => {
  const expires = new Date("2099-12-31T23:59:59Z");

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;${
    isLocalhost ? "" : "domain=.bigfootmail.com;"
  }SameSite=Lax`;
};

export const getCookie = (name) => {
  const nameEQ = `${name}=`;

  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith(nameEQ)) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }

  return null;
};
